// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__w4T3G","textArea__white":"TextArea_textArea__white__nFU3K","textArea__label":"TextArea_textArea__label__rk6zC"};